import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EmopPublicWorkflowApprovalApiService } from '../../emop-public-workflow-approval-api.service';
import { EmopPublicWorkflowApprovalService } from '../../emop-public-workflow-approval.service';
@Component({
  selector: 'app-emop-public-workflow-approval-form',
  templateUrl: './emop-public-workflow-approval-form.component.html',
  styleUrls: ['./emop-public-workflow-approval-form.component.scss']
})
export class EmopPublicWorkflowApprovalFormComponent implements OnInit {
  action = '审核通过';
  comments = '';
  constructor(
    private EmopPublicWorkflowApprovalApiService: EmopPublicWorkflowApprovalApiService,
    public EmopPublicWorkflowApprovalService: EmopPublicWorkflowApprovalService
  ) { }
  @Output() confirm = new EventEmitter;
  ngOnInit(): void {
  }
  approvalConfirm() {
    this.EmopPublicWorkflowApprovalService.submitLoading = true;
    this.EmopPublicWorkflowApprovalApiService.approvalFlow(this.EmopPublicWorkflowApprovalService.processNodeId, JSON.stringify(this.EmopPublicWorkflowApprovalService.formData.getData())).subscribe((rs) => {
      this.EmopPublicWorkflowApprovalService.submitLoading = false;
      this.confirm.emit(rs);
    });
  }
}
